import type { Expression } from 'mapbox-gl';

/** POI tile types rendered by Coordal transport layers — exclude from ghana-poi-labels. */
export const TRANSPORT_POI_AMENITY_TYPES = [
  'bus_station',
  'bus_stop',
  'taxi',
  'car_wash',
  'car_rental',
  'ferry_terminal',
  'parking',
  'parking_entrance',
  'parking_space',
  'motorcycle_parking',
  'bicycle_parking',
  'car_repair',
  'bicycle_rental',
  'bicycle_repair_station',
  'charging_station',
  'car_pooling',
  'car_sharing',
] as const;

/** Maki slugs owned by transport — never map to coordal-poi-* icons. */
export const TRANSPORT_POI_MAKI_SLUGS = new Set([
  'bus',
  'car',
  'parking',
  'ferry',
  'bicycle-share',
  'charging-station',
  'car-repair',
  'harbor',
]);

/** Hide transport amenities on ghana-poi-labels; transport layers own those features. */
export const HIDE_TRANSPORT_POI_FROM_LABELS: Expression = [
  '!',
  [
    'all',
    ['==', ['get', 'class'], 'amenity'],
    ['in', ['get', 'type'], ['literal', [...TRANSPORT_POI_AMENITY_TYPES]]],
  ],
];

/** public_transport class features are rendered on transport tile layers. */
export const HIDE_PUBLIC_TRANSPORT_FROM_POI_LABELS: Expression = [
  '!=',
  ['get', 'class'],
  'public_transport',
];

/** Non-POI OSM classes that should not appear on ghana-poi-labels. */
export const HIDE_NON_POI_CLASSES_FROM_LABELS: Expression = [
  '!',
  ['in', ['get', 'class'], ['literal', ['barrier', 'highway', 'waterway', 'water']]],
];

export function mergePoiLabelsFilter(existing: unknown): Expression {
  const transportFilters: Expression[] = [
    HIDE_TRANSPORT_POI_FROM_LABELS,
    HIDE_PUBLIC_TRANSPORT_FROM_POI_LABELS,
    HIDE_NON_POI_CLASSES_FROM_LABELS,
  ];
  if (!Array.isArray(existing)) {
    return ['all', ...transportFilters];
  }
  if (existing[0] === 'all') {
    return [...existing, ...transportFilters] as unknown as Expression;
  }
  return ['all', existing, ...transportFilters] as Expression;
}
